import { render, staticRenderFns } from "./RepaymentsReport.vue?vue&type=template&id=0513e694&scoped=true&"
import script from "./RepaymentsReport.vue?vue&type=script&lang=js&"
export * from "./RepaymentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513e694",
  null
  
)

export default component.exports